module.exports = __webpack_public_path__ + "static/img/bg-01-m.11b2d23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-01-m.jpg
// module id = fUDV
// module chunks = 98